export default __webpack_public_path__ + "static/media/line-v-18.5531e9c5.png";